/* eslint-disable no-nested-ternary */
import styled from '@emotion/styled';
import { dropdownColors } from 'app/colors';
import { Row, Col } from 'react-bootstrap';
import { breakpoints } from 'app/spacing';
import {
  fontSizes,
  TextSpan,
  KizenTypography,
  fontWeights,
} from 'app/typography';
import TextInput from 'components/Inputs/TextInput';
import { CardBasic } from 'components/Card/Card';
import ImageFileInputWithUploadBase from 'components/Kizen/FileInputWithImage/WithUpload';
import Button from 'components/Button';
import Notice from 'components/Kizen/Notice';

export const CardContainer = styled.div`
  > div {
    margin-bottom: 20px;
  }
`;

export const ButtonsContainer = styled.div`
  > :not(:first-child) {
    margin-left: 20px;
  }
`;

export const StyledRow = styled(Row)`
  margin-bottom: 20px;
  &.no-margin {
    margin-bottom: 0;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  &.margin {
    margin-bottom: 20px;
  }
`;

export const StyledCol = styled(Col)`
  padding: 0 10px;
  flex-basis: 50%;
  @media (min-width: ${breakpoints.md}px) {
    flex-basis: 0;
  }
`;

export const StyledFormInput = styled(TextInput)`
  & input[type='password'] {
    -webkit-text-security: disc;
    text-security: disc;
  }
  &.credit-card div span {
    display: flex;
    align-self: flex-end;
  }
`;

export const StyledFormError = styled(KizenTypography)`
  margin-top: 15px;
  text-align: center;
  color: var(--color-viz-cat-7-primary);
`;

export const WysiwygWrapper = styled.div`
  && {
    flex: 1;
    resize: none;
    outline: none;
    margin-top: 12px;
  }
`;

export const StyledLabel = styled(TextSpan)`
  color: var(--color-font-primary);
  display: flex;
`;

export const StyledAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: ${fontSizes.buttonLabel};
  font-weight: ${fontWeights.bold};
  margin: 0;
  line-height: 100%;
  letter-spacing: 0.8px;

  color: var(--color-button-primary-default);
  border: unset;
  :hover {
    text-decoration: none;
    color: var(--color-button-primary-hover);
  }
  :active {
    color: var(--color-button-primary-hover);
  }
  :focus {
    text-decoration: none;
    color: var(--color-button-primary-hover);
  }
  :disabled {
    opacity: 1;
    color: var(--color-background-medium);
  }
`;

export const ActionsIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const ActionsIcon = styled.div`
  text-align: right;
  cursor: pointer;
  > i {
    font-size: 16px;
  }
`;

export const ActionsContainer = styled.div`
  position: relative;
`;

export const ActionsMenu = styled.div`
  border: 1px solid var(--color-border-medium);
  background-color: var(--color-background-white);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  button {
    color: var(--color-font-primary);
    font-weight: normal;
    font-size: ${fontSizes.text};
    line-height: 17px;
    letter-spacing: -0.00125em;
    text-transform: none;
    padding: 10px;
    height: auto;
    line-height: 100%;
    margin: 0;
    border-radius: 0;
  }
  button:first-of-type {
    border-bottom: 1px solid var(--color-border-medium);
  }
  button:hover {
    color: var(--color-font-primary);
    background-color: ${dropdownColors.hover};
  }
`;

export const ProfileCard = styled(CardBasic)`
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  > div:last-of-type {
    flex: 1;
  }
`;

export const ApiCard = styled(ProfileCard)`
  min-height: 500px;
  max-height: 500px;
`;

export const ImageFileInputWithUpload = styled(ImageFileInputWithUploadBase)`
  margin-bottom: 23px;
`;

export const StyledLinkButton = styled(Button)`
  &&& {
    font-size: 14px;
    height: 1em;
    display: flex;
    letter-spacing: unset;
    padding: 0;

    div:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledMfaWrapper = styled.div`
  display: flex;
  gap: 20px;
`;

export const StyledNotice = styled(Notice)`
  margin-bottom: 12px;
`;
